import React from "react";
import Footer from "components/footer";
import EditProfile from "./components/editProfile";
import { Container } from "components";

const UpdateProfile = () => {
  return (
    <Container>
      <div class="content-wrapper">
        <EditProfile />
        <Footer />
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};

export default UpdateProfile;
